import { SUB_GROUP_SHELL_TITLE } from "../constants/subGroupShellTitle.constants";

export const getSubGroupShellTitle = (subGroupShellKey: string | null) => {
  if (!subGroupShellKey) return null;

  return SUB_GROUP_SHELL_TITLE[subGroupShellKey];
};
